// extracted by mini-css-extract-plugin
export default {"Cancel":"globalButtonStylng_Cancel__W-Nwg","Basic":"globalButtonStylng_Basic__MGR3L","Submit":"globalButtonStylng_Submit__UsCqo"};